import axios from 'axios'
import { AUTH_SERVICE_URL, } from '../helper/constant'
import { cacheService } from '../helper/utils'
import { PORTAL_INSTANCE } from '..'
import { userEventsChecker } from '../helper/user-session-handler'
import { isJWTTokenExpired, jwtBase64URLdecode } from './Auth'

export const REPORTS = {
    DISPLAY: 'Reports Display',
    SEARCH: 'Reports Search',
    RECEPTION: 'Reception Reports',
    BOOKING: 'Booking Reports',
    REVENUE_SHARE: 'Revenue Share Reports',
    VALUE_BACK: 'Value Back Reports',
    SERVICEFEE_BOOKING: 'ServiceFee Booking Reports',
    MISCELLANEOUS: 'Miscellaneous Reports',
    PORTAL_DOCS: 'Portal Docs'
}

class AuthHomeCustomer {

    static portalId
    static clientId

    static _userInfo
    static refreshTK
    static token
    static expiry

    static userId   //We can have userId from cognitoTokens.
    static isSupervisor
    static isReports
    static isSuperUser
    static email
    static phone
    static userCountryCode
    static fullName

    static userCountryShortcut
    static UOMmultiplier

    static username
    static userRole
    static isAdminUser
    static isUser
    static isManager
    static isApiUser
    static cultureId

    static reqTypes = [];
    static countries = [];
    static reportModule = [];

    static logoutFn;

    static _clearUserProps() {
        this._userInfo = undefined

        this.token = undefined
        this.refreshTK = undefined
        this.expiry = undefined

        this.userId = undefined
        this.username = undefined
        this.isSupervisor = undefined
        this.isReports = undefined
        this.isSuperUser = undefined
        this.email = undefined
        this.phone = undefined
        this.userRole = undefined
        this.userCountryCode = undefined
        this.fullName = undefined

        this.isAdminUser = false;
        this.isApiUser = false;
        this.isUser = false;
        this.isManager = false;
        this.cultureId = undefined;
        //default value of request
        this.portalId = PORTAL_INSTANCE.pId
        this.clientId = PORTAL_INSTANCE.cId
    }

    static _clearUserCache() {
        //console.log('Token Cache clear')
        const hkey = `${PORTAL_INSTANCE.hkey}${this.portalId}_`
        cacheService.removeCache(hkey)
        cacheService.removeCache(PORTAL_INSTANCE.ekey)
        cacheService.removeCache('reqTypes')
        cacheService.removeCache('countries')
        cacheService.removeCache('reportModule')
        cacheService.removeCache('releaseVersion')
        cacheService.removeCache('releaseVersionShown')
        cacheService.removeCache('userCountryShortcut')
        cacheService.removeCache('UOMMultiplier')
    }

    static setUserData(userInfo) {
        let { token } = userInfo
        if (token && !isJWTTokenExpired(token)) {
            console.log('--------------------------------Home Auth set User-----------------------------')
            userInfo = this._userInfo = JSON.parse(JSON.stringify(userInfo))
            if (userInfo && userInfo.token) {
                let decoded = jwtBase64URLdecode(userInfo.token)
                let tokenOpt = {
                    expiry: new Date(decoded.exp * 1000),
                    created: new Date(decoded.iat * 1000),
                }

                Object.assign(this, userInfo, tokenOpt)
                //caching data
                const hkey = `${PORTAL_INSTANCE.hkey}${userInfo.portalId}_`
                cacheService.setCache(hkey, this._userInfo)
                cacheService.setCache(PORTAL_INSTANCE.ekey, this._userInfo);
                cacheService.setCache('releaseVersion', this._userInfo['releaseVersion']);

                //fix things
                if (!this.isSupervisor && this.isRequestManager) {
                    this.isSupervisor = true;
                }

                if (userInfo.clientId && typeof userInfo.clientId != 'number') {
                    this._userInfo.clientId = userInfo.clientId = parseInt(userInfo.clientId)
                }
                if (userInfo.portalId && typeof userInfo.portalId != 'number') {
                    this._userInfo.portalId = userInfo.portalId = parseInt(userInfo.portalId)
                }
                //set user portal if changed
                let { cId, pId } = PORTAL_INSTANCE
                if (!(cId === userInfo.clientId && pId === userInfo.portalId)) {
                    PORTAL_INSTANCE.cId = userInfo.clientId
                    PORTAL_INSTANCE.pId = userInfo.portalId
                }
                //Fix things
                this.userRole = (this.isAdminUser ? 'Admin' :
                    (this.isManager ? 'Manager' :
                        (this.isApiUser ? 'Super User' :
                            (this.isUser ? 'User' : ''))))



                userEventsChecker.registerEvents(AuthHomeCustomer)
            }
        }
    }

    static initialize() {
        console.log('--------------------------------Home Auth initialize-----------------------------')
        this._clearUserProps();
        let userInfo = cacheService.getCache(PORTAL_INSTANCE.ekey) || {};
        console.log(PORTAL_INSTANCE.ekey, (userInfo && userInfo.userId))
        this.setUserData(userInfo)
    }

    static get isTokenExpired() {
        let { token, expiry } = this._userInfo || {};
        let now = new Date()
        if (token && expiry) {
            let isExpired = ((expiry.getTime() - now.getTime()) <= 0)
            return isExpired
        }
        return false;
    }

    static get isTokenAboutToExpire() {
        let { token, expiry } = this._userInfo || {};
        let now = new Date()
        if (token && expiry) {
            let gapExpiry = 10 * 60 * 1000//less than 10 minute
            let isExpired = (expiry.getTime() - now.getTime()) <= gapExpiry
            // let dis = (expiry.getTime() - now.getTime() - gapExpiry) / 1000
            // let min = Math.round(dis / 60)
            // let sec = Math.round(dis - min * 60)
            // console.log('isTokenAboutToExpire ', min, 'mins', sec, 'secs')

            // console.log("isTokenAboutToExpire", isExpired)
            return isExpired
        }
        return false;
    }
    static get isRefreshTKExpired() {
        let { refreshTK: token, expiryRTK: expiry } = this._userInfo || {};
        let now = new Date()
        if (token && expiry) {
            let isExpired = ((expiry.getTime() - now.getTime()) <= 0)
            return isExpired
        }
        return false;
    }

    static get isUserAuthenticated() {
        return (this.token && !this.isTokenExpired);
    }

    static async verifyUserMFA(args) {
        console.log('--------------------------------verifyUserMFA-----------------------------')
        this._clearUserCache();
        let headers = {
            "Content-Type": "application/json"
        }
        const VERIFY_URL = `${AUTH_SERVICE_URL}/portal/loginMFAVerify`
        const { data } = await axios.post(VERIFY_URL, args, { headers })
        this.setUserData(data.data);

        return { token: this.token }
    }

    static logout() {
        console.log('--------------------------------logout-----------------------------')
        this._clearUserProps()
        this._clearUserCache();
    }

    static doLogout() {
        this.logout()
        if (typeof this.logoutFn === 'function') {
            this.logoutFn();
        }
    }

    static subscribeTokenExpiry(fn) {
        this.logoutFn = fn;
    }

    static setUserGroup(data = []) {
        let reqTypes = [];
        let countries = [];
        let reportModule = [];

        if (data.length) {
            data.forEach(grMapping => {
                if (grMapping.reqTypeInfo && grMapping.reqTypeInfo.length) {
                    grMapping.reqTypeInfo.forEach(reqType => {
                        reqTypes.push(reqType.reqTypeId);
                    })
                }
                if (grMapping.countryInfo && grMapping.countryInfo.length) {
                    grMapping.countryInfo.forEach(c => {
                        countries.push(c.countryId);
                    })
                }
                if (grMapping.moduleInfo && grMapping.moduleInfo.length) {
                    grMapping.moduleInfo.forEach(md => {
                        if (md && md.moduleInfo) {
                            reportModule.push(md.moduleInfo.name);

                        }
                    })
                }
            })
        }

        this.reqTypes = reqTypes;
        this.countries = countries;
        this.reportModule = reportModule;

        cacheService.setCache('reqTypes', reqTypes)
        cacheService.setCache('countries', countries)
        cacheService.setCache('reportModule', reportModule)
    }

    static setUserCountryShortCut(data) {
        cacheService.setCache('userCountryShortcut', data)
    }

    static getUserCountryShortCut() {
        return cacheService.getCache('userCountryShortcut') || 'IND'
    }

    static setUOMMultiplier(data) {
        let multiplier = parseFloat(data.multiplier);
        if (isNaN(multiplier)) {
            multiplier = 1;
        }
        if (!data.uom) data.uom = 'cm';
        data.multiplier = multiplier;
        cacheService.setCache('UOMMultiplier', data)
    }

    static getUOMMultiplier() {
        let result = 1;
        let resultData = cacheService.getCache('UOMMultiplier');
        if (resultData && resultData.multiplier) {
            result = resultData.multiplier
        }
        return result;
    }

    static getUOMName() {
        let result = 'cm';
        let resultData = cacheService.getCache('UOMMultiplier');
        if (resultData && resultData.uom) {
            result = resultData.uom
        }
        return result;
    }

    static getUserGroup() {
        const _reqTypes = cacheService.getCache('reqTypes') || [];
        const _countries = cacheService.getCache('countries') || [];
        const _reportModule = cacheService.getCache('reportModule') || [];

        this.reqTypes = this.reqTypes.length ? this.reqTypes : _reqTypes;
        this.countries = this.countries.length ? this.countries : _countries;
        this.reportModule = this.reportModule.length ? this.reportModule : _reportModule;
        return {
            reqTypes: this.reqTypes,
            countries: this.countries,
            reportModule: this.reportModule,
        }
    }

    static isHasReport(report = '') {
        if (!report || !this.reportModule.length) return false;
        report = report.toString().replace(/ /g, '').toUpperCase();
        let result = this.reportModule.find(rp => rp.toString().replace(/ /g, '').toUpperCase() === report);
        return result;
    }
    //refreshToken
    static async refreshAuthJWT() {
        // console.log('--------------------------------refreshAuthJWT-----------------------------')
        let { refreshTK, portalId, userId } = this
        if (!(userId && portalId && refreshTK)) {
            console.log('Having NO user profile and refresh token!')
            return
        }

        let isExpired = isJWTTokenExpired(refreshTK)
        if (isExpired) {
            console.log('Refresh token NOT exists or Already expired!')
            return
        }

        const URL = `${AUTH_SERVICE_URL}/portal/refreshToken`;
        let headers = {
            "x-userid": this.userId,
        }

        const { data } = await axios.post(URL, { refreshTK, portalId, userId }, { headers });
        this.setUserData(data.data)
    }
}

export default AuthHomeCustomer;



